const MAX_CANDLES = 120;
export function timeframeToSeconds(timeframe) {
    switch (timeframe) {
        case '5s':
            return 5;
        case '1m':
            return 60;
        case '5m':
            return 300;
        case '15m':
            return 900;
        case '30m':
            return 1800;
        case '1h':
            return 3600;
        default:
            return 60;
    }
}
export function buildCandlesFromTicks(ticks, intervalSeconds) {
    if (ticks.length === 0) {
        return [];
    }
    const candles = [];
    let current = null;
    let lastTickTime = -Infinity;
    for (const tick of ticks) {
        if (!Number.isFinite(tick.time) || !Number.isFinite(tick.value)) {
            continue;
        }
        const tickOpen = Number.isFinite(tick.open) ? tick.open : tick.value;
        const tickHigh = Number.isFinite(tick.high) ? tick.high : tick.value;
        const tickLow = Number.isFinite(tick.low) ? tick.low : tick.value;
        const tickClose = Number.isFinite(tick.close) ? tick.close : tick.value;
        const tickTime = Math.trunc(tick.time);
        if (tickTime < lastTickTime) {
            continue;
        }
        lastTickTime = tickTime;
        const bucketTime = floorToBucket(tickTime, intervalSeconds);
        if (!current || bucketTime > current.time) {
            current = {
                time: bucketTime,
                open: tickOpen,
                high: Math.max(tickHigh, tickOpen, tickClose),
                low: Math.min(tickLow, tickOpen, tickClose),
                close: tickClose
            };
            candles.push(current);
            continue;
        }
        current.high = Math.max(current.high, tickHigh, tickClose);
        current.low = Math.min(current.low, tickLow, tickClose);
        current.close = tickClose;
    }
    const slicedCandles = candles.length > MAX_CANDLES ? candles.slice(-MAX_CANDLES) : candles;
    return slicedCandles;
}
export function floorToBucket(time, intervalSeconds) {
    return (Math.floor(time / intervalSeconds) * intervalSeconds);
}
